export const setPMT = ({ BACEN, BACEN_CONJUGE, BACEN_PJ }: { BACEN?: number, BACEN_CONJUGE?: number, BACEN_PJ?: number }) => ({
  type: 'SET_PMT',
  payload: {
    BACEN,
    BACEN_CONJUGE,
    BACEN_PJ
  }
})
